import { render, staticRenderFns } from "./offer-single.vue?vue&type=template&id=f0635cec&"
import script from "./offer-single.vue?vue&type=script&lang=js&"
export * from "./offer-single.vue?vue&type=script&lang=js&"
import style0 from "./offer-single.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports